import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
//specific
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DynamicFormComponent} from 'app/core-ui/dynamic-form/containers/dynamic-form/dynamic-form.component';
import {AuthFlowSetupService} from './authFlowSetup.service';

@Component({
  selector: 'authFlowSetup-grid',
  templateUrl: './authFlowSetup.component.html',
  providers: [AuthFlowSetupService],
})
export class AuthFlowSetupComponent extends BaseGridNoCookieComponent<AuthFlowSetupService> {
  @ViewChild(DynamicFormComponent) public form: DynamicFormComponent;
  public group = 'authFlowSetup';
  constructor(
    public gridService: AuthFlowSetupService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    visualsService: VisualsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(securityService, logger, visualsService, gridService);

    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
      },
    });
  }

  public goToEdit(bean: any) {
    this.router.navigate(['menu/7214'], {
      queryParams: {
        actionCd: bean.actionCd,
        cmpId: this.form.value['companyId'],
      },
    });
  }

  //Grid Search Form Modal Handler
  handleModalOutput(event: any) {
    if (event.modalname == 'companyModal') {
      this.form.setValue('companyId', event.value.cmpId);
    }
  }
}
